<template lang="pug">
    div.pagination(v-if="lastPage > 1")
        ul
            li.button(:class="{'disabled': onFirstPage}")
                a(@click.prevent="prevPage")
                    include ../../snippets/arrow-prev.pug

            li(v-for="page in pages" :class="page")
                a.page-link(@click.prevent="updatePage(page.value)") {{page.value}}

            li.button(:class="{'disabled': onLastPage}")
                a(@click.prevent="nextPage")
                    include ../../snippets/arrow-next.pug
</template>

<script>
    export default {
        props: {
            value: {
                type: Number,
                required: true
            },
            pageCount: {
                type: Number,
                required: true,
                default: 1
            },
        },
        computed: {
            firstPage() {
                return 1
            },
            lastPage() {
                return this.pageCount
            },
            onFirstPage() {
                return this.currentPage === this.firstPage
            },
            onLastPage() {
                return this.currentPage === this.lastPage
            },
            currentPage() {
                return this.value
            },
            pages() {
                let valPrev = this.value > 1 ? (this.value - 1) : 1;
                let valNext = this.value < this.pageCount ? (this.value + 1) : this.pageCount;
                let extraPrev = valPrev === 3 ? 2 : null;
                let extraNext = valNext === (this.pageCount - 2) ? (this.pageCount - 1) : null;
                let dotsBefore = valPrev > 3 ? 2 : null;
                let dotsAfter = valNext < (this.pageCount - 2) ? (this.pageCount - 1) : null;
                let pages = [];
                for (let i = 1; i <= this.pageCount; i += 1) {
                    if ([1, this.pageCount, this.value, valPrev, valNext, extraPrev, extraNext, dotsBefore, dotsAfter].includes(i)) {
                        pages.push({
                            value: i,
                            current: this.value === i,
                            disabled: [dotsBefore, dotsAfter].includes(i)
                        })
                    }
                }
                return pages;
            },
        },
        methods: {
            nextPage() {
                this.updatePage(this.currentPage + 1)
            },
            prevPage() {
                this.updatePage(this.currentPage - 1)
            },
            updatePage(pageNumber) {
                if (pageNumber <= this.lastPage && pageNumber >= this.firstPage) {
                    this.$emit('update', pageNumber)
                }
            }
        }
    }
</script>
